import { z } from 'zod';

export const paginationMetaSchema = z.object({
  page: z.number(),
  limit: z.number(),
  totalItems: z.number(),
  totalPages: z.number(),
  hasNextPage: z.boolean(),
  hasPrevPage: z.boolean(),
});

export type PaginationMeta = z.infer<typeof paginationMetaSchema>;

export function createListEnvelopeSchema<T extends z.ZodTypeAny>(
  itemSchema: T
) {
  return z
    .object({
      data: z.array(itemSchema),
      meta: paginationMetaSchema.optional(),
    })
    .transform(raw => ({
      items: raw.data,
      meta: raw.meta ?? {
        page: 1,
        limit: raw.data.length || 10,
        totalItems: raw.data.length,
        totalPages: 1,
        hasNextPage: false,
        hasPrevPage: false,
      },
    }));
}

export function createItemEnvelopeSchema<T extends z.ZodTypeAny>(
  itemSchema: T
) {
  return z.object({ data: itemSchema }).transform(raw => raw.data);
}

export interface ListResult<T> {
  items: T[];
  meta: PaginationMeta;
}

export interface PaginationParams {
  page?: number;
  limit?: number;
}
